import ColorPicker from "@/v2/shared/components/ColorPicker/ColorPicker";
import { selectLayoutConfig } from "@/v2/views/Tour/Settings/selectors";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ControlLabel, Toggle } from "rsuite";

export default function LayoutConfiguration({
  id,
  onChange,
}: {
  id: string;
  onChange: (value: { primaryColor: string; enabled: boolean }) => void;
}) {
  const layoutConfig = useSelector(selectLayoutConfig(id));
  const [primaryColor, setPrimaryColor] = useState(layoutConfig.primaryColor);
  const [enabled, setEnabled] = useState(layoutConfig.enabled);

  const handlePrimaryColorChange = (value: string) => {
    setPrimaryColor(value);
  };

  const handleEnabledChange = (value: boolean) => {
    setEnabled(value);
  };

  useEffect(() => {
    onChange({ primaryColor, enabled });
  }, [primaryColor, enabled]);

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <ControlLabel style={{ display: "block", marginBottom: 5 }}>
          Enable custom colors:
        </ControlLabel>
        <Toggle
          checkedChildren="On"
          unCheckedChildren="Off"
          defaultChecked={enabled}
          onChange={(selected) => handleEnabledChange(selected)}
        />
      </div>
      <div>
        <ControlLabel style={{ display: "block", marginBottom: 5 }}>
          Primary color:
        </ControlLabel>
        <ColorPicker
          presetColors={["#34281A", "#6083cb", "#DD8062", "#62ddb1", "#62bedd"]}
          value={primaryColor}
          onChange={(value) => handlePrimaryColorChange(value)}
        />
      </div>
    </div>
  );
}
